import withList from '../../with-list/main';
import { selectors, actions } from './';
import table from './table-initial-data';

export default withList(selectors, actions, table, {
	link: '/blog/article-tags/editor',
	text: 'Create article tag'
});


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/blog/article-tag/list/main.js